import {
  getIsOverall,
  getSelectedDistrict,
  getSelectedSport,
  getSelectedState,
  selectHideEmptyResults,
} from 'app/imports/App.selectors'
import { UISpinner } from 'features/UI'
import { useSelector } from 'react-redux'
import { useGetStandingsQuery } from '../../state/Standings.rtk'
import { StandingsTable } from '../StandingsTable/StandingsTable'
import * as Styled from './Standings.styled'

export function Standings() {
  const state = useSelector(getSelectedState)
  const district = useSelector(getSelectedDistrict)
  const sport = useSelector(getSelectedSport)
  const isOverall = useSelector(getIsOverall)
  const isHideEmptyResults = useSelector(selectHideEmptyResults)

  const { data, isFetching } = useGetStandingsQuery(
    {
      stateId: state?.id,
      districtId: district?.id,
      sportId: sport?.id,
      isOverall,
      showEmptyResults: !isHideEmptyResults,
    },
    {
      skip: !state || !district || !sport,
      refetchOnMountOrArgChange: true,
    },
  )

  if (!sport) {
    return <Styled.Container>Please select a sport</Styled.Container>
  }

  if (isFetching || !data) {
    return (
      <Styled.Container>
        <UISpinner />
      </Styled.Container>
    )
  }

  if (!data.standings || data.standings?.length === 0) {
    return <Styled.Container>No standings</Styled.Container>
  }

  return <StandingsTable standings={data.standings} />
}
